import {Accordion, AccordionDetails, AccordionSummary, Box, Divider, Typography} from "@mui/material";

interface IVideoRule {
    config: any
    rule: string
}
export function VideoRule({config, rule}: IVideoRule) {
    return (
        <Accordion>
            <AccordionSummary>
                <Typography>{rule}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box display="flex">
                    <Typography sx={{flexGrow: 1}}><strong>Preset:</strong></Typography>
                    <Typography>{config.video_export.base.rules[rule].preset}</Typography>
                </Box>
                <Divider/>
                {Object.keys(config.video_export.base.rules[rule].files)
                    .filter(key => key !== "preset").map(file =>
                        <Typography key={file}>
                            {config.video_export.base.rules[rule].files[file].toString()}
                        </Typography>
                    )}
            </AccordionDetails>
        </Accordion>
    );
}